// extracted by mini-css-extract-plugin
export default {"aboutUsContainer":"about_us_aboutUsContainer__C29as"};